import React from 'react';
import { I18n } from '@aws-amplify/core';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { useGetOrganizations } from '@/hooks/useGetOrganizations';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';

export function OrganizationFormItem() {
	const { data: organizations = [] } = useGetOrganizations();
	return (
		<FormItemWrapper
			name="organization_id"
			label={<LabelMediumRegular>{I18n.get('Company')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
			required
		>
			<SelectOptions allowClear loading={false} options={organizations} placeholder={I18n.get('Company')} />
		</FormItemWrapper>
	);
}
